import type {ReactNode} from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  id?: string;
  onClick?: () => void;
}

export default function Card({children, className = '', hover = false, id, onClick}: CardProps) {
  return (
    <div
      id={id}
      onClick={onClick}
      className={`rounded-xl bg-white border border-border p-6 ${
        hover ? 'transition-all duration-200 hover:shadow-lg hover:border-t-[3px] hover:border-t-secondary' : 'shadow-sm'
      } ${className}`}
    >
      {children}
    </div>
  );
}

export function CardHeader({children, className = ''}: {children: ReactNode; className?: string}) {
  return <div className={`mb-4 ${className}`}>{children}</div>;
}

export function CardBody({children, className = ''}: {children: ReactNode; className?: string}) {
  return <div className={className}>{children}</div>;
}
